<template>
  <div class="w-100 h-100 d-flex flex-column">
    <div class="row m-0">
      <div class="col">
        <div class="menu-tab-text menu-select-color">プロパティ</div>
      </div>
    </div>

    <!-- 境界線 -->
    <div class="line" />

    <div v-if="$store.state.selectDraftDesign" class="w-100 h-100 p-0 m-0">
      <p class="fw-bold m-2" style="font-size: 28px;">{{ productSize }}</p>
      <div class="fw-bold p-2 border-0" style="background: #F5F7FA;">{{ editedNum }}/{{ quantity }} 編集済み</div>

      <p class="m-2 text-start" style="font-size: 13px;">金額</p>
      <p class="fw-bold m-2 text-end mb-0" style="font-size: 13px;">{{totalPrice}}円</p>
      <div class="line" />

      <p class="m-2 text-start" style="font-size: 13px;">( 1枚単価 <span class="status-error-color">{{discountText}}</span> )</p>
      <p class="fw-bold m-2 text-end mb-0" style="font-size: 13px;">{{price}}円</p>
      <div class="line" />

      <p class="m-2 text-start" style="font-size: 13px;">数量</p>

      <div class="fw-bold m-2 text-end mb-0 d-flex justify-content-end" style="font-size: 13px;">
        <input type="number" min="1" max="1000" v-model="acrylNum" @blur="numBlur" class="forminput fw-bold text-end no-spin border border-1" />
        <span>枚</span>
      </div>
      <div class="line" />
      <p class="acry-text-title m-2" style="font-size: 0.75em; ">※数量を変更すると編集がリセットされます</p>
    </div>

    <div class="mt-auto" v-if="$store.state.selectDraftDesign" >
      <!-- 境界線 -->
      <!-- <div class="line mb-4" /> -->
      <div class="">
        <button @click="contenueEdit" class="acry-btn-secondary-normal w-100" style="height:38px;">つづきから</button>
      </div>
      <div class="my-3">
        <button @click="newEdit" class="acry-btn-secondary-normal w-100" style="height:38px;">はじめから</button>
      </div>
      <div class="my-3">
        <button @click="deleteDesign" class="acry-btn-secondary-normal w-100" style="height:38px;">削除</button>
      </div>
      <!-- 境界線 -->
      <div class="line" />
      <div class="col-auto my-3">
        <button class="acry-btn-primary-normal w-100" style="height:38px;" @click="addCart">カートに入れる</button>
      </div>
    </div>
  </div>
</template>

<script>
// import { User } from "@/js/User.js";
// import JSZip from "jszip";
// import { ProductData } from "@/js/ProductData.js";

import { FirebaseCommon } from "@/js/FirebaseCommon.js";
// import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import { ProductId, GetAcryProductPrice, GetAcryProductSizeText } from "@/js/Const.js";
import { ProductData } from "@/js/ProductData.js";
import { EditDesignPreparation, DiscountRatio, CreateFrameCutlineImage } from "@/js/CommonFunc.js";
import { CenterViewState, RightViewState } from "@/js/Const.js";
import { Big } from 'big.js';
import { Analytics } from "@/js/Analytics.js";

export default {
  name: "RightMenuDraft_Ap",
  props: {},
  data: function () {
    return {
      discountText: "",
      totalPrice: 0,  // 合計金額（税抜）
      price: 0,       // 割引後の1枚あたりの金額
      acrylNum: 0,
    };
  },
  watch: {
    "$store.state.selectDraftDesign": function () {
      // 商品が選択される
      if(this.$store.state.selectDraftDesign){
        this.acrylNum = this.quantity;
        this.updatePriceText();
      }
    },
  },
  computed: {
    productSize() {
      switch (this.$store.state.selectDraftDesign.productId) {
        case ProductId.S:
        case ProductId.S_SVG:
        case ProductId.S_SHARE:
          return "Sサイズ";
        case ProductId.M:
        case ProductId.M_SVG:
        case ProductId.M_SHARE:
          return "Mサイズ";
        case ProductId.L:
        case ProductId.L_SVG:
        case ProductId.L_SHARE:
          return "Lサイズ";
        default:
          return "";
      }
    },
    editedNum() {
      return this.$store.state.selectDraftDesign?this.$store.state.selectDraftDesign.editedNum:0;
    },
    quantity() {
      return this.$store.state.selectDraftDesign?this.$store.state.selectDraftDesign.quantity:0;
    },
    designId() {
      return this.$store.state.selectDraftDesign.designId;
    },
    isDraft() {
      return this.$store.state.selectDraftDesign.isDraft;
    },
  },
  async created() {
    this.$store.commit("showLoading");
    await this.$store.state.cartManager.update().catch(() => {});
    this.$store.commit("hideLoading");
  },
  components: {},
  methods: {
    numBlur(){
      if( isNaN(this.acrylNum) ) this.acrylNum = 1;
      if( this.acrylNum < 1 ) this.acrylNum = 1;
      if( this.acrylNum > 1000 ) this.acrylNum = 1000;
      this.updatePriceText();
    },
    // ===== タブ周り ===== //
    async addCart() {
      // プログレスバーを表示
      this.$store.commit("showProgress");
      this.$store.commit("setProgressMessages", [
        "デザインデータを作成中…",
        "しばらくお待ちください",
      ]);

      // デザインデータをまとめたZIPを取得
      let info = await FirebaseCommon.downloadDesignZip(this.designId);
      this.$store.commit("setProgress", 5);

      // サーバーから現在販売中の商品の情報を取得
      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideProgress");
        this.$store.commit("showMessage", "エラーが発生しました");
        return;
      });
      this.$store.commit("setProgress", 10);

      // 販売中の商品リストからカートに追加する商品の情報を取得
      let saleProduct = this.$store.state.saleProductManager.getProduct(this.$store.state.selectDraftDesign.productId );
      this.$store.commit("setProgress", 15);

      // プロダクトデータを作成
      let p = new ProductData(
        saleProduct,
        saleProduct.productData["product_class_list2"][0]
      );

      // テキストの情報を設定
      await p.createDataForJson(info, this.designId);

      // 個数が変更された場合は編集をリセット
      if (this.acrylNum != this.quantity) {
        // 初めからの場合は編集状態をリセット
        p.canvasDatas[0].itemList = [];
        p.quantity = parseInt(this.acrylNum);
      }

      // デザイン画像とカットライン画像をダウンロードしvuexに保存
      await EditDesignPreparation(this.designId, this.$store.state.selectDraftDesign.productId, info.productJson.isShareCodeDraft,this.$store);
      this.$store.commit("setProgress", 20);

      // vuexに保存されている画像を設定
      await p.canvasDatas[0].setBaseImage(
        this.$store.state.designImageFile,
        this.$store.state.designImageURL,
        (info.productJson.isShareCodeDraft)?this.$store.state.scCutlineImageFile:this.$store.state.cutlineImageFile,
        this.$store.state.frameCutlineImageURL
      );
      this.$store.commit("setProgress", 25);

      let self = this;
      await this.$store.state.cartManager.addCartProduct(p, false, function(progress){
        self.$store.commit("setProgress", 25 + (75 / 100 * progress));
      }).catch((e) => {
        this.$store.commit("hideProgress");
        this.$common.log(e);
        this.$store.commit("showMessage", "エラーが発生しました");
        return;
      });

      // 割引後の単価を計算
      const productPrice = GetAcryProductPrice(this.$store.state.selectDraftDesign.productId);
      const totalQuantity = parseInt(this.$store.state.cartManager.getCartProductQuantity(this.$store.state.selectDraftDesign.productId));
      const ratio = DiscountRatio(totalQuantity);
      // 丸め誤差が出ないようにライブラリを使用して計算
      const priceBase = new Big(productPrice.priceBase);
      const priceRatio = new Big(100-ratio).div(100);
      const discountPrice = priceBase.times(priceRatio);

      const productSizeTxt = GetAcryProductSizeText(this.$store.state.selectDraftDesign.productId);
      Analytics.addToCartAcrylic(this.$store.state.selectDraftDesign.productId, saleProduct.productName, p.quantity, discountPrice.toNumber(), productSizeTxt );

      this.$store.commit("hideProgress");
      this.$store.commit("showMessage", "カートに追加しました");

      // 表示を戻す
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      this.$store.commit("setRightViewState", RightViewState.Cart);
    },
    async contenueEdit() {
      await this.designEdit(false);
    },
    async newEdit() {
      await this.designEdit(true);
    },

    // デザインを編集するための準備を行い
    async designEdit( isNewEdit ){
      this.$store.commit("showLoading");

      let info = await FirebaseCommon.downloadDesignZip(this.designId);
      console.log(info);

      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "エラーが発生しました");
        this.$store.commit("hideLoading");
        return;
      });

      let saleProduct = this.$store.state.saleProductManager.getProduct(
        this.$store.state.selectDraftDesign.productId
      );

      let p = new ProductData(
        saleProduct,
        saleProduct.productData["product_class_list2"][0]
      );
      await p.createDataForJson(info, this.designId);
      p.setDraftId(this.designId);  // 下書きから編集に遷移したことを保存


      if( isNewEdit ){
        // 初めからの場合は編集状態をリセット
        p.canvasDatas[0].itemList = [];
        p.quantity = parseInt(this.acrylNum);
      }else{
        if (this.acrylNum != this.quantity) {
          // 初めからの場合は編集状態をリセット
          p.canvasDatas[0].itemList = [];
          p.quantity = parseInt(this.acrylNum);
        }
      }

      await EditDesignPreparation(
        this.designId,
        this.$store.state.selectDraftDesign.productId,
        info.productJson.isShareCodeDraft,
        this.$store
      );

      this.$store.commit("addProduct", p);
      this.$store.commit("hideModal");
      this.$store.commit("selectCanvasData", p.canvasDatas[0]);

      await this.$store.state.currentCanvasData.setBaseImage(
        this.$store.state.designImageFile,
        this.$store.state.designImageURL,
        (info.productJson.isShareCodeDraft)?this.$store.state.scCutlineImageFile:this.$store.state.cutlineImageFile,
        this.$store.state.frameCutlineImageURL
      );

      this.$store.commit("setSelectProductId", this.$store.state.selectDraftDesign.productId);

      // プレビューの設定
      this.$store.commit("resetDesignPreviewData");
      this.$store.commit("setDesignPreviewData", { key: 'selectProductId', value: this.$store.state.selectDraftDesign.productId});
      this.$store.commit("setDesignPreviewData", { key: 'designImageURL', value: URL.createObjectURL(this.$store.state.designImageFile)});
      if( info.productJson.isShareCodeDraft ) {
        this.$store.commit("setDesignPreviewData", { key: 'originalCutlineImageURL', value: this.$store.state.scCutlineImageURL});
        const ContourImageBlob = await CreateFrameCutlineImage(this.$store.state.scCutlineImageURL);
        this.$store.commit("setDesignPreviewData", { key: 'cutlineContourImageURL', value: URL.createObjectURL(ContourImageBlob)});
      }else{
        this.$store.commit("setDesignPreviewData", { key: 'originalCutlineImageURL', value: this.$store.state.cutlineImageURL});
        const ContourImageBlob = await CreateFrameCutlineImage(this.$store.state.cutlineImageURL);
        this.$store.commit("setDesignPreviewData", { key: 'cutlineContourImageURL', value: URL.createObjectURL(ContourImageBlob)});
      }

      // 編集用のUIに変更
      this.$store.commit("setCenterViewState", CenterViewState.Edit);
      this.$store.commit("setRightViewState", RightViewState.Edit);

      this.$store.commit("hideLoading");
    },

    updatePriceText(){
      if( this.acrylNum == 0 ){
        this.totalPrice = this.totalTax = this.price = 0;
        this.discountText = "";
      }else{
        let productPrice = GetAcryProductPrice(this.$store.state.selectDraftDesign.productId);
        let productTotal = parseInt(this.acrylNum) + parseInt(this.$store.state.cartManager.getCartProductQuantity(this.$store.state.selectDraftDesign.productId));
        let ratio = DiscountRatio(productTotal);

        if( ratio == 0 ){
          this.discountText = "";
        }else{
          this.discountText = ratio + "%割引適応";
        }

        // 丸め誤差が出ないようにライブラリを使用して計算
        let priceBaseTotal = new Big(this.acrylNum * productPrice.priceBase); // 税抜き価格の合計
        let priceRatio = new Big(100-ratio).div(100);
        let totalPrice = priceBaseTotal.times(priceRatio);
        this.totalPrice = Math.floor(totalPrice.toNumber());
        this.price = Math.floor(this.totalPrice / this.acrylNum);


        // let discount = (productPrice.price * this.acrylNum) * (DiscountRatio(this.acrylNum)/100);
        // this.totalPrice = Math.ceil((this.acrylNum * productPrice.priceBase));
        // //this.totalTax = Math.ceil((this.acrylNum * productPrice.price) * (1-ratio/100) - this.totalPrice);
        // this.price = Math.ceil((this.totalPrice - discount) / this.acrylNum);
      }
    },

    async deleteDesign(){
      await this.$store.state.draftManager.delete(this.designId).catch(() => {
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "エラーが発生しました");
      });

      this.$store.commit("setSelectDraftDesign", null);
    }

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* タブ関連 */

.line {
  height: 1px;
  background-color: #e6e5eb;
}

.item-scroll {
  /* background-color: rgb(132, 135, 133); */
  display: flex;
  flex-direction: column;
  height: 500px;
  overflow-y: scroll;
}

.list-scroll {
  /* background-color: rgb(132, 135, 133); */
  display: flex;
  flex-direction: column;
  height: 500px;
  overflow-y: scroll;
}

.scroll {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  align-items: left;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
}

.select-box {
  width: 100%;
  padding: 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid #999;
  background: #eee;
  /* background: url(arrow01.png) right 50% no-repeat, -webkit-linear-gradient(top, #fff 0%,#efebe1 100%);
	background: url(arrow01.png) right 50% no-repeat, linear-gradient(to bottom, #fff 0%,#efebe1 100%); */
  background-size: 20px, 100%;
}

.number-field {
  margin-right: 10px;
  padding: 0.25rem;
  width: 70px;
  border: solid 0px #ffffff;
  border-radius: 4px;
  background-color: #e6e5eb;
}

.forminput {
  width: 25%;
  border: 0;
}


</style>
